import styled from 'styled-components'
import { ArrowRightIcon, ArrowLeftIcon, BulletsIcon } from '~/styles/Icons'

import fonts from '~/utils/fonts'

export const PaginationWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  flex-shrink: 0;
`

export const PaginationStyle = styled.div`
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: fit-content;
  margin: 0 auto;
`

export const PreviousButton = styled.button`
  width: 30px;
  height: 30px;
  background-image: url(${ArrowLeftIcon});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 50px 50px;
  margin-right: 10px;
  flex-shrink: 0;
`

export const NextButton = styled.button`
  width: 30px;
  height: 30px;
  background-image: url(${ArrowRightIcon});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 50px 50px;
  flex-shrink: 0;
`

export const PageButton = styled.button`
  width: 44px;
  height: 44px;
  border: 4px solid var(--color-light);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-black);
  font-family: ${fonts.displayRegular};
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  margin-right: 10px;
  flex-shrink: 0;

  ${({ active }) =>
    active
      ? `
  border: 4px solid var(--color-black);
  background: var(--color-black);
  color: var(--color-white);
  `
      : ``}
`

export const Bullets = styled.img`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
  align-self: flex-end;

  /* background-image: url(${BulletsIcon}); */
  /* background-position: center 20px;
  background-repeat: no-repeat;
  background-size: 28px 28px; */
`
